
// import pdfIcon from "./../../../assets/images/pdf.png"; // Adjust the path as necessary
// import { WebApiURL } from '../../../Constants/Constants';
// import React, { useEffect,useMemo,useState } from 'react';
// import { useFileContext } from '../../../Contexts/FileContext';

// function RFQSubmissions() {
//    const [activeIndex, setActiveIndex] = useState(0);
// const { setComponentName, setSection, documents, loading } = useFileContext();
//   useEffect(() => {
//     setComponentName("Request for Quotation");
//   }, [setComponentName]);
// // Extract unique sections dynamically
//   const sections = useMemo(() => {
//     const sectionSet = new Set();
//     documents?.forEach((doc) => {
//       const section = typeof doc?.section === 'string' ? doc.section.trim() : '';
//       if (section) sectionSet.add(section);
//     });
//     return Array.from(sectionSet);
//   }, [documents]);
//   const renderDocumentsBySection = (sectionName) => {
//     const docs = documents?.filter(doc =>
//       String(doc?.section || '').trim().toLowerCase() === String(sectionName || '').trim().toLowerCase()
//     );
//  const grouped = docs?.reduce((acc, doc) => {
//     const folder = doc?.folderName || doc?.section || "Uncategorized";
//     if (!acc[folder]) acc[folder] = [];
//     acc[folder].push(doc);
//     return acc;
//   }, {});
//   return (
//     <ul className="strip-ul">
//       {Object.entries(grouped).map(([folderName, folderDocs], idx) => (
//         <li key={idx}>
//           <div className="row g-4">
//             <div className="col-auto">
//               <img src={pdfIcon} alt="PDF icon" />
//             </div>
//             <div className="col">
//               <div className="row g-4">
//                 <div className="col-md">
//                   <div className="font-18 font-600">File Name</div>
//                   <div className="font-16 font-400">
//                     <p className="text-orange-ef3e33 text-uppercase">
//                       {folderName}
//                     </p>
//                     <ul className="list">
//                       {folderDocs.map((doc, i) => (
//                         <li key={i}>
//                           <a
//                             href={`${WebApiURL}File/view/${encodeURIComponent(doc.fileId)}`}
//                             target="_blank"
//                             rel="noopener noreferrer"
//                           >
//                             {doc.fileName}
//                           </a>
//                         </li>
//                       ))}
//                     </ul>
//                   </div>
//                 </div>
//                 <div className="col-md-auto">
//                   <div className="font-18 font-600">CLOSING DATE</div>
//                   <div className="font-16 font-400">
//                     {folderDocs[0]?.modifiedDate
//                       ? new Date(folderDocs[0].modifiedDate).toLocaleString()
//                       : "—"}
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </li>
//       ))}
//     </ul>
//   );
//   };
// return (
//     <>
//       <div className="service-title text-green-38B652 font-700 mb-3">
//         Request for Quotation  
//         <span className="text-orange-ef3e33 font-400"></span>
//       </div>

//       <div className="row g-3 g-sm-4 g-md-4">
//         <div className="col-12">       
//           <div className="accordion blackTab" id="blackTab">
//                       {sections?.map((sectionName, idx) => (
//               <div className="accordion-item" key={sectionName}>
//                 <h2 className="accordion-header">
//                   <button
//                     className={`accordion-button ${activeIndex !== idx ? "collapsed" : ""}`}
//                     type="button"
//                     data-bs-toggle="collapse"
//                     data-bs-target={`#section-${idx}`}
//                     aria-expanded={idx === 0 ? "true" : "false"}
//                     aria-controls={`section-${idx}`}
//                     onClick={() => setActiveIndex(idx)}
//                   >
//                     {sectionName}
//                   </button>
//                 </h2>
//                 <div
//                   id={`section-${idx}`}
//                   className={`accordion-collapse collapse ${activeIndex === idx ? "show" : ""}`}
//                   data-bs-parent="#blackTab"
//                 >
//                   <div className="accordion-body px-0">
//                     {loading ? (
//                       <div>Loading documents...</div>
//                     ) : (
//                       renderDocumentsBySection(sectionName)
//                     )}
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>


//       </div>
//     </>
//   );
// }

// export default RFQSubmissions;



// import pdfIcon from "./../../../assets/images/pdf.png"; // Adjust the path as necessary
// import { WebApiURL } from '../../../Constants/Constants';
// import React, { useEffect, useMemo, useState } from 'react';
// import { useFileContext } from '../../../Contexts/FileContext';
// import CryptoJS from "crypto-js";
// import { encryptFileIdValue } from "../../../utils/encryption";

// function RFQSubmissions() {
//   const [activeIndex, setActiveIndex] = useState(0); 

//   const { setComponentName, setSection, documents, loading } = useFileContext();
//   useEffect(() => {
//     setComponentName("Request for Quotation");
//   }, [setComponentName]);
//   // Extract unique sections dynamically
//   const sections = useMemo(() => {
//     const sectionSet = new Set();
//     documents?.forEach((doc) => {
//       const section = typeof doc?.section === 'string' ? doc.section.trim() : '';
//       if (section) sectionSet.add(section);
//     });
//     return Array.from(sectionSet);
//   }, [documents]);

//   const getDocumentBySection = (sectionName) => {
//     const docs = documents?.filter(doc =>
//       String(doc?.section || '').trim().toLowerCase() === String(sectionName || '').trim().toLowerCase()
//     );

//     return (
//       <>
//         <div className="row w-100 m-0">
//           {/* <div className="row"> */}
//           {/* Section Name */}
//           <div className="col-12 col-md-6 fw-semibold">
//             <span>{sectionName}</span>
//           </div>

//           <div className="col-12 col-md-2 text-md">
//             <span className="d-none d-md-inline fw-semibold">Open Date: </span><br />
//             <span>
//               {docs?.[0]?.openDate && !isNaN(new Date(docs[0].openDate))
//                 ? new Date(docs[0].openDate).toLocaleDateString("en-GB")
//                 : ""}
//             </span>
//           </div>


//           {/* Closing Date */}
//           <div className="col-12 col-md-3 text-md">

//             <span className="d-none d-md-inline fw-semibold">Close Date & Time: </span><br />
//             <span>
//               {docs?.[0]?.closingDate && !isNaN(new Date(docs[0].closingDate))
//                 ? new Date(docs[0].closingDate).toLocaleString("en-GB", {
//                   day: "2-digit",
//                   month: "2-digit",
//                   year: "numeric",
//                   hour: "2-digit",
//                   minute: "2-digit"
//                 })
//                 : ""}
//             </span>
//           </div>
//           <div className="col-12 col-md-1 text-md-end">
//             <span className="d-none d-md-inline fw-semibold">Status: </span><br />
//             <span>
//               {docs?.[0]?.status ? ` ${docs[0].status}` : ""}
//             </span>
//           </div>
//         </div>
//       </>
//     );
//   };
//   const encodeBase64 = (str) => btoa(unescape(encodeURIComponent(str)));
//   const renderDocumentsBySection = (sectionName) => {
//     const docs = documents?.filter(doc =>
//       String(doc?.section || '').trim().toLowerCase() === String(sectionName || '').trim().toLowerCase()
//     );
//     const grouped = docs?.reduce((acc, doc) => {
//       const folder = doc?.folderName || doc?.section || "Uncategorized";
//       if (!acc[folder]) acc[folder] = [];
//       acc[folder].push(doc);
//       return acc;
//     }, {});
//     return (
//       <ul className="strip-ul">
//         {Object.entries(grouped).map(([folderName, folderDocs], idx) => (
//           <li key={idx}>
//             <div className="row g-4">            
//               <div className="col">
//                 <div className="row g-4">
//                   <div className="col-md">                    
//                     <div className="font-16 font-400">
//                       <div className="container">
//                         <div className="row tender-header d-none d-md-flex">
//                           <div className="col-md-6 fw-semibold">File Name</div>
//                           <div className="col-md-2 fw-semibold text-end">Open Date</div>
//                           <div className="col-md-2 fw-semibold text-end">Closing Date</div>
//                           <div className="col-md-2 fw-semibold text-end">Status</div>
//                         </div>
//                         {folderDocs.map((doc, i) => (
//                           <div
//                             key={i}
//                             className={`row tender-row ${i % 2 === 0 ? "even" : "odd"}`}
//                           >
//                             <div className="col-12 col-md-6 text-truncate">
//                               <span className="d-md-none fw-semibold">File Name: </span>                              
//                               <a
//                                 href={`${WebApiURL}File/view/${encryptFileIdValue(doc.fileId)}`}
//                                 rel="noopener noreferrer"
//                               >{doc.fileName}</a>
//                             </div>

//                             <div className="col-12 col-md-2 text-md-end">
//                               <span className="d-md-none fw-semibold">Open Date: </span>
//                               {doc.openDate && !isNaN(new Date(doc.openDate))
//                                 ? new Date(doc.openDate).toLocaleDateString("en-GB")
//                                 : ""}
//                             </div>

//                             {/* /QA */}
//                             <div className="col-12 col-md-3 text-md-center">
//                               <span className="d-md-none fw-semibold">Closing Date: </span>
//                               {doc.closingDate && !isNaN(new Date(doc.closingDate))
//                                 ? new Date(doc.closingDate).toLocaleString("en-GB", {
//                                   day: "2-digit",
//                                   month: "2-digit",
//                                   year: "numeric",
//                                   hour: "2-digit",
//                                   minute: "2-digit",
//                                   hour12: false
//                                 })
//                                 : ""}
//                             </div>                            
//                             <div className="col-12 col-md-1 text-md-end">
//                               <span className="d-md-none fw-semibold">Status: </span>
//                               {doc.status && typeof doc.status === "string" ? doc.status : ""}
//                             </div>
//                           </div>
//                         ))}
//                       </div>
//                     </div>
//                   </div>
//                   <div className="col-md-auto">
//                     <div className="font-16 font-400">                      
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </li>
//         ))}
//       </ul>
//     );
//   };
//   return (
//     <>
//       <div className="service-title text-green-38B652 font-700 mb-3 d-flex justify-content-between align-items-center mb-3">
//         Request for Quotation
//         <span className="text-orange-ef3e33 font-400"></span>
//         <button className="btn btn-outline-primary" >
//           Print
//         </button>
//       </div>
//       <div className="row g-3 g-sm-4 g-md-4">
//         <div className="col-12">
//           <div className="accordion blackTab" id="blackTab">
//             {sections?.map((sectionName, idx) => (
//               <div className="accordion-item" key={sectionName}>
//                 <h2 className="accordion-header">
//                   <button
//                     className={`accordion-button ${activeIndex !== idx ? "collapsed" : ""}`}
//                     type="button"
//                     data-bs-toggle="collapse"
//                     data-bs-target={`#section-${idx}`}
//                     aria-expanded={idx === 0 ? "true" : "false"}
//                     aria-controls={`section-${idx}`}
//                     onClick={() => setActiveIndex(idx)}
//                   >
//                     {getDocumentBySection(sectionName)}
//                   </button>
//                 </h2>
//                 <div
//                   id={`section-${idx}`}
//                   className={`accordion-collapse collapse ${activeIndex === idx ? "show" : ""}`}
//                   data-bs-parent="#blackTab"
//                 >
//                   <div className="accordion-body px-0">
//                     {loading ? (
//                       <div>Loading documents...</div>
//                     ) : (
//                       renderDocumentsBySection(sectionName)
//                     )}
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }

// export default RFQSubmissions;


// import pdfIcon from "./../../../assets/images/pdf.png"; // Adjust the path as necessary
// import { WebApiURL } from '../../../Constants/Constants';
// import React, { useEffect, useMemo, useState, useRef } from 'react';
// import { useFileContext } from '../../../Contexts/FileContext';
// import CryptoJS from "crypto-js";
// import { encryptFileIdValue } from "../../../utils/encryption";
// import ReactToPrint from 'react-to-print';

// function RFQSubmissions() {
//   const [activeIndex, setActiveIndex] = useState(0);
//   const { setComponentName, setSection, documents, loading } = useFileContext();

//   // 👇 Ref to capture the accordion for printing
//   const printRef = useRef(null);

//   useEffect(() => {
//     setComponentName("Request for Quotation");
//   }, [setComponentName]);

//   // Extract unique sections dynamically
//   const sections = useMemo(() => {
//     const sectionSet = new Set();
//     documents?.forEach((doc) => {
//       const section = typeof doc?.section === 'string' ? doc.section.trim() : '';
//       if (section) sectionSet.add(section);
//     });
//     return Array.from(sectionSet);
//   }, [documents]);

//   // ✅ Print only the accordion area
//   const handlePrint = () => {
//     if (!printRef.current) return;
    
//     const printContent = printRef.current.innerHTML;
//     const newWindow = window.open('', '', 'width=1200,height=650');
//     newWindow.document.write(`
//       <html>
//         <head>
//           <title>Print Preview - Request for Quotation</title>
//           <style>
//             body { font-family: Arial, sans-serif; padding: 20px; }
//             .accordion-button { background: #f8f9fa; font-weight: bold; }
//             .accordion-item { border: 1px solid #ddd; margin-bottom: 10px; border-radius: 6px; }
//             .accordion-body { padding: 10px 20px; }
//             table, th, td { border-collapse: collapse; }
            
// @media print {
//   .tender-header {
//     display: none !important;
//   }
    
// .accordion-button {
//   display: flex;
//   flex-direction: row; /* Default row for large screens */
//   justify-content: space-between;
// }
// .btn-green-38B652 {
// padding: 1px 20px !important;
// }

//   .print-card {
//     display: flex;
//     flex-direction: column;
//     width: 100%;
//     border: 1px solid #000;
//     padding: 10px;
//     box-sizing: border-box;
//     font-family: Arial, sans-serif;
//     font-size: 14px;
//   }


// .accordion-button {
//         display: block;
//         width: 100% !important;
//         text-align: left;
//         box-sizing: border-box;
        
//       }

// }

//           </style>
//         </head>
//         <body>
//           ${printContent}
//         </body>
//       </html>
//     `);
//     newWindow.document.close();
//     newWindow.focus();
//     newWindow.print();
//     newWindow.close();
//   };

//   const getDocumentBySection = (sectionName) => {
//     const docs = documents?.filter(doc =>
//       String(doc?.section || '').trim().toLowerCase() === String(sectionName || '').trim().toLowerCase()
//     );

//     return (
//       <div className="row w-100 m-0">
//         <div className="col-12 col-md-6 fw-semibold">
//           <span>{sectionName}</span>
//         </div>
//         <div className="col-12 col-md-2 text-md">
//           <span className="d-none d-md-inline fw-semibold">Open Date: </span><br />
//           <span>
//             {docs?.[0]?.openDate && !isNaN(new Date(docs[0].openDate))
//               ? new Date(docs[0].openDate).toLocaleDateString("en-GB")
//               : ""}
//           </span>
//         </div>
//         <div className="col-12 col-md-3 text-md">
//           <span className="d-none d-md-inline fw-semibold">Close Date & Time: </span><br />
//           <span>
//             {docs?.[0]?.closingDate && !isNaN(new Date(docs[0].closingDate))
//               ? new Date(docs[0].closingDate).toLocaleString("en-GB", {
//                 day: "2-digit",
//                 month: "2-digit",
//                 year: "numeric",
//                 hour: "2-digit",
//                 minute: "2-digit"
//               })
//               : ""}
//           </span>
//         </div>
//         <div className="col-12 col-md-1 text-md-end">
//           <span className="d-none d-md-inline fw-semibold">Status: </span><br />
//           <span>
//             {docs?.[0]?.status ? ` ${docs[0].status}` : ""}
//           </span>
//         </div>
//       </div>
//     );
//   };

//   const renderDocumentsBySection = (sectionName) => {
//     const docs = documents?.filter(doc =>
//       String(doc?.section || '').trim().toLowerCase() === String(sectionName || '').trim().toLowerCase()
//     );
//     const grouped = docs?.reduce((acc, doc) => {
//       const folder = doc?.folderName || doc?.section || "Uncategorized";
//       if (!acc[folder]) acc[folder] = [];
//       acc[folder].push(doc);
//       return acc;
//     }, {});
//     return (
//       <ul className="strip-ul">
//         {Object.entries(grouped).map(([folderName, folderDocs], idx) => (
//           <li key={idx}>
//             <div className="row g-4">
//               <div className="col">
//                 <div className="row g-4">
//                   <div className="col-md">
//                     <div className="font-16 font-400">
//                       <div className="container">
//                         <div className="row tender-header d-none d-md-flex">
//                           <div className="col-md-6 fw-semibold">File Name</div>
//                           <div className="col-md-2 fw-semibold text-end">Open Date</div>
//                           <div className="col-md-2 fw-semibold text-end">Closing Date</div>
//                           <div className="col-md-2 fw-semibold text-end">Status</div>
//                         </div>
//                         {folderDocs.map((doc, i) => (
//                           <div
//                             key={i}
//                             className={`row tender-row ${i % 2 === 0 ? "even" : "odd"}`}
//                           >
//                             <div className="col-12 col-md-6 text-truncate">
//                               <span className="d-md-none fw-semibold">File Name: </span>
//                               <a
//                                 href={`${WebApiURL}File/view/${encryptFileIdValue(doc.fileId)}`}
//                                 rel="noopener noreferrer"
//                               >{doc.fileName}</a>
//                             </div>
//                             <div className="col-12 col-md-2 text-md-end">
//                               <span className="d-md-none fw-semibold">Open Date: </span>
//                               {doc.openDate && !isNaN(new Date(doc.openDate))
//                                 ? new Date(doc.openDate).toLocaleDateString("en-GB")
//                                 : ""}
//                             </div>
//                             <div className="col-12 col-md-3 text-md-center">
//                               <span className="d-md-none fw-semibold">Closing Date: </span>
//                               {doc.closingDate && !isNaN(new Date(doc.closingDate))
//                                 ? new Date(doc.closingDate).toLocaleString("en-GB", {
//                                   day: "2-digit",
//                                   month: "2-digit",
//                                   year: "numeric",
//                                   hour: "2-digit",
//                                   minute: "2-digit",
//                                   hour12: false
//                                 })
//                                 : ""}
//                             </div>
//                             <div className="col-12 col-md-1 text-md-end">
//                               <span className="d-md-none fw-semibold">Status: </span>
//                               {doc.status && typeof doc.status === "string" ? doc.status : ""}
//                             </div>
//                           </div>
//                         ))}
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </li>
//         ))}
//       </ul>
//     );
//   };

//   return (
//     <>
//       <div className="service-title text-green-38B652 font-700 mb-3 d-flex justify-content-between align-items-center mb-3">
//         Request for Quotation
//         <button className="about-btn btn-green-38B652 d-inline-block text-decoration-none"  onClick={handlePrint}>
//           Print
//         </button>
//       </div>

//       {/* 👇 Wrapped accordion inside ref */}
//       <div className="row g-3 g-sm-4 g-md-4" ref={printRef}>
//         <div className="col-12">
//           <div className="accordion blackTab" id="blackTab">
//             {sections?.map((sectionName, idx) => (
//               <div className="accordion-item" key={sectionName}>
//                 <h2 className="accordion-header">
//                   <button
//                     className={`accordion-button ${activeIndex !== idx ? "collapsed" : ""}`}
//                     type="button"
//                     data-bs-toggle="collapse"
//                     data-bs-target={`#section-${idx}`}
//                     aria-expanded={idx === 0 ? "true" : "false"}
//                     aria-controls={`section-${idx}`}
//                     onClick={() => setActiveIndex(idx)}
//                   >
//                     {getDocumentBySection(sectionName)}
//                   </button>
//                 </h2>
//                 <div
//                   id={`section-${idx}`}
//                   className={`accordion-collapse collapse ${activeIndex === idx ? "show" : ""}`}
//                   data-bs-parent="#blackTab"
//                 >
//                   <div className="accordion-body px-0">
//                     {loading ? (
//                       <div>Loading documents...</div>
//                     ) : (
//                       renderDocumentsBySection(sectionName)
//                     )}
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }

// export default RFQSubmissions;

// import pdfIcon from "./../../../assets/images/pdf.png";
// import { WebApiURL } from "../../../Constants/Constants";
// import React, { useEffect, useMemo, useState, useRef } from "react";
// import { useFileContext } from "../../../Contexts/FileContext";
// import { encryptFileIdValue } from "../../../utils/encryption";

// function RFQSubmissions() {
//   const [activeIndex, setActiveIndex] = useState(0);
//   const [searchTerm, setSearchTerm] = useState(""); // 🔍 Added search state
//   const { setComponentName, documents, loading } = useFileContext();
//   const printRef = useRef(null);

//   useEffect(() => {
//     setComponentName("Request for Quotation");
//   }, [setComponentName]);

//   // ✅ Filter documents based on search term (file name, section, status)
//   const filteredDocuments = useMemo(() => {
//     if (!documents) return [];
//     const search = searchTerm.toLowerCase();
//     return documents.filter((doc) => {
//       const fileName = (doc.fileName || "").toString().toLowerCase();
//       const section = (doc.section || "").toString().toLowerCase();
//       const status = (doc.status || "").toString().toLowerCase();
//       return (
//         fileName.includes(search) ||
//         section.includes(search) ||
//         status.includes(search)
//       );
//     });
//   }, [documents, searchTerm]);

//   // Extract unique sections dynamically (after filtering)
//   const sections = useMemo(() => {
//     const sectionSet = new Set();
//     filteredDocuments.forEach((doc) => {
//       const section = typeof doc?.section === "string" ? doc.section.trim() : "";
//       if (section) sectionSet.add(section);
//     });
//     return Array.from(sectionSet);
//   }, [filteredDocuments]);

//   // ✅ Print only the accordion area
//   const handlePrint = () => {
//     if (!printRef.current) return;
//     const printContent = printRef.current.innerHTML;
//     const newWindow = window.open("", "", "width=1200,height=650");
//     newWindow.document.write(`
//       <html>
//         <head>
//           <title>Print Preview - Request for Quotation</title>
//           <style>
//             body { font-family: Arial, sans-serif; padding: 20px; }
//             .accordion-button { background: #f8f9fa; font-weight: bold; }
//             .accordion-item { border: 1px solid #ddd; margin-bottom: 10px; border-radius: 6px; }
//             .accordion-body { padding: 10px 20px; }
//             .tender-header { display: none !important; }
//             .accordion-button { display: block; text-align: left; width: 100%; }
//           </style>
//         </head>
//         <body>${printContent}</body>
//       </html>
//     `);
//     newWindow.document.close();
//     newWindow.focus();
//     newWindow.print();
//     newWindow.close();
//   };

//   // ✅ Section Header Info
//   const getDocumentBySection = (sectionName) => {
//     const docs = filteredDocuments.filter(
//       (doc) =>
//         String(doc?.section || "").trim().toLowerCase() ===
//         String(sectionName || "").trim().toLowerCase()
//     );

//     return (
//       <div className="row w-100 m-0">
//         <div className="col-12 col-md-6 fw-semibold">
//           <span>{sectionName}</span>
//         </div>
//         <div className="col-12 col-md-2 text-md">
//           <span className="d-none d-md-inline fw-semibold">Open Date: </span>
//           <br />
//           <span>
//             {docs?.[0]?.openDate && !isNaN(new Date(docs[0].openDate))
//               ? new Date(docs[0].openDate).toLocaleDateString("en-GB")
//               : ""}
//           </span>
//         </div>
//         <div className="col-12 col-md-3 text-md">
//           <span className="d-none d-md-inline fw-semibold">
//             Close Date & Time:
//           </span>
//           <br />
//           <span>
//             {docs?.[0]?.closingDate && !isNaN(new Date(docs[0].closingDate))
//               ? new Date(docs[0].closingDate).toLocaleString("en-GB", {
//                   day: "2-digit",
//                   month: "2-digit",
//                   year: "numeric",
//                   hour: "2-digit",
//                   minute: "2-digit",
//                 })
//               : ""}
//           </span>
//         </div>
//         <div className="col-12 col-md-1 text-md-end">
//           <span className="d-none d-md-inline fw-semibold">Status: </span>
//           <br />
//           <span>{docs?.[0]?.status ? ` ${docs[0].status}` : ""}</span>
//         </div>
//       </div>
//     );
//   };

//   // ✅ Render Documents by Section
//   const renderDocumentsBySection = (sectionName) => {
//     const docs = filteredDocuments.filter(
//       (doc) =>
//         String(doc?.section || "").trim().toLowerCase() ===
//         String(sectionName || "").trim().toLowerCase()
//     );

//     const grouped = docs.reduce((acc, doc) => {
//       const folder = doc?.folderName || doc?.section || "Uncategorized";
//       if (!acc[folder]) acc[folder] = [];
//       acc[folder].push(doc);
//       return acc;
//     }, {});

//     return (
//       <ul className="strip-ul">
//         {Object.entries(grouped).map(([folderName, folderDocs], idx) => (
//           <li key={idx}>
//             <div className="row g-4">
//               <div className="col">
//                 <div className="row g-4">
//                   <div className="col-md">
//                     <div className="font-16 font-400">
//                       <div className="container">
//                         <div className="row tender-header d-none d-md-flex">
//                           <div className="col-md-6 fw-semibold">File Name</div>
//                           <div className="col-md-2 fw-semibold text-end">
//                             Open Date
//                           </div>
//                           <div className="col-md-2 fw-semibold text-end">
//                             Closing Date
//                           </div>
//                           <div className="col-md-2 fw-semibold text-end">
//                             Status
//                           </div>
//                         </div>
//                         {folderDocs.map((doc, i) => (
//                           <div
//                             key={i}
//                             className={`row tender-row ${
//                               i % 2 === 0 ? "even" : "odd"
//                             }`}
//                           >
//                             <div className="col-12 col-md-6 text-truncate">
//                               <span className="d-md-none fw-semibold">
//                                 File Name:{" "}
//                               </span>
//                               <a
//                                 href={`${WebApiURL}File/view/${encryptFileIdValue(
//                                   doc.fileId
//                                 )}`}
//                                 rel="noopener noreferrer"
//                               >
//                                 {doc.fileName}
//                               </a>
//                             </div>
//                             <div className="col-12 col-md-2 text-md-end">
//                               <span className="d-md-none fw-semibold">
//                                 Open Date:{" "}
//                               </span>
//                               {doc.openDate &&
//                               !isNaN(new Date(doc.openDate))
//                                 ? new Date(doc.openDate).toLocaleDateString(
//                                     "en-GB"
//                                   )
//                                 : ""}
//                             </div>
//                             <div className="col-12 col-md-3 text-md-center">
//                               <span className="d-md-none fw-semibold">
//                                 Closing Date:{" "}
//                               </span>
//                               {doc.closingDate &&
//                               !isNaN(new Date(doc.closingDate))
//                                 ? new Date(
//                                     doc.closingDate
//                                   ).toLocaleString("en-GB", {
//                                     day: "2-digit",
//                                     month: "2-digit",
//                                     year: "numeric",
//                                     hour: "2-digit",
//                                     minute: "2-digit",
//                                     hour12: false,
//                                   })
//                                 : ""}
//                             </div>
//                             <div className="col-12 col-md-1 text-md-end">
//                               <span className="d-md-none fw-semibold">
//                                 Status:{" "}
//                               </span>
//                               {doc.status && typeof doc.status === "string"
//                                 ? doc.status
//                                 : ""}
//                             </div>
//                           </div>
//                         ))}
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </li>
//         ))}
//       </ul>
//     );
//   };

//   return (
//     <>
//       {/* ✅ Header with search + print button */}
//       <div className="service-title text-green-38B652 font-700 mb-3 d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-2">
//         <div>Request for Quotation</div>
//         <div className="d-flex flex-wrap gap-2">
//           <input
//             type="text"
//             className="form-control form-control-sm"
//             style={{ width: "250px" }}
//             placeholder="Search by file, section, or status..."
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//           />
//           <button
//             className="about-btn btn-green-38B652 text-decoration-none"
//             onClick={handlePrint}
//           >
//             Print
//           </button>
//         </div>
//       </div>

//       {/* 👇 Accordion section (filtered & printable) */}
//       <div className="row g-3 g-sm-4 g-md-4" ref={printRef}>
//         <div className="col-12">
//           {sections.length === 0 ? (
//             <p className="text-muted">No matching documents found.</p>
//           ) : (
//             <div className="accordion blackTab" id="blackTab">
//               {sections.map((sectionName, idx) => (
//                 <div className="accordion-item" key={sectionName}>
//                   <h2 className="accordion-header">
//                     <button
//                       className={`accordion-button ${
//                         activeIndex !== idx ? "collapsed" : ""
//                       }`}
//                       type="button"
//                       data-bs-toggle="collapse"
//                       data-bs-target={`#section-${idx}`}
//                       aria-expanded={idx === 0 ? "true" : "false"}
//                       aria-controls={`section-${idx}`}
//                       onClick={() => setActiveIndex(idx)}
//                     >
//                       {getDocumentBySection(sectionName)}
//                     </button>
//                   </h2>
//                   <div
//                     id={`section-${idx}`}
//                     className={`accordion-collapse collapse ${
//                       activeIndex === idx ? "show" : ""
//                     }`}
//                     data-bs-parent="#blackTab"
//                   >
//                     <div className="accordion-body px-0">
//                       {loading ? (
//                         <div>Loading documents...</div>
//                       ) : (
//                         renderDocumentsBySection(sectionName)
//                       )}
//                     </div>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           )}
//         </div>
//       </div>
//     </>
//   );
// }

// export default RFQSubmissions;

import pdfIcon from "./../../../assets/images/pdf.png";
import { WebApiURL } from "../../../Constants/Constants";
import React, { useEffect, useMemo, useState, useRef } from "react";
import { useFileContext } from "../../../Contexts/FileContext";
import { encryptFileIdValue } from "../../../utils/encryption";

function RFQSubmissions() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [searchTerm, setSearchTerm] = useState(""); // 🔍 Search state
  const { setComponentName, documents, loading } = useFileContext();
  const printRef = useRef(null);

  useEffect(() => {
    setComponentName("Request for Quotation");
  }, [setComponentName]);

  // 🔍 Enhanced Search: FileName + Section + Status + OpenDate + ClosingDate
  const filteredDocuments = useMemo(() => {
    if (!documents) return [];
    const search = searchTerm.toLowerCase();

    return documents.filter((doc) => {
      const fileName = (doc.fileName || "").toString().toLowerCase();
      const section = (doc.section || "").toString().toLowerCase();
      const status = (doc.status || "").toString().toLowerCase();

      // Convert open/close dates to formatted strings
      const openDateStr =
        doc.openDate && !isNaN(new Date(doc.openDate))
          ? new Date(doc.openDate)
              .toLocaleString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
              })
              .toLowerCase()
          : "";

      const closingDateStr =
        doc.closingDate && !isNaN(new Date(doc.closingDate))
          ? new Date(doc.closingDate)
              .toLocaleString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
              })
              .toLowerCase()
          : "";

      return (
        fileName.includes(search) ||
        section.includes(search) ||
        status.includes(search) ||
        openDateStr.includes(search) ||
        closingDateStr.includes(search)
      );
    });
  }, [documents, searchTerm]);

  // Extract unique sections dynamically (based on filtered results)
  const sections = useMemo(() => {
    const sectionSet = new Set();
    filteredDocuments.forEach((doc) => {
      const section = typeof doc?.section === "string" ? doc.section.trim() : "";
      if (section) sectionSet.add(section);
    });
    return Array.from(sectionSet);
  }, [filteredDocuments]);

  // ✅ Print only accordion area
  const handlePrint = () => {
    if (!printRef.current) return;
    const printContent = printRef.current.innerHTML;
    const newWindow = window.open("", "", "width=1200,height=650");
    newWindow.document.write(`
      <html>
        <head>
          <title>Print Preview - Request for Quotation</title>
          <style>
            body { font-family: Arial, sans-serif; padding: 20px; }
            .accordion-button { background: #f8f9fa; font-weight: bold; }
            .accordion-item { border: 1px solid #ddd; margin-bottom: 10px; border-radius: 6px; }
            .accordion-body { padding: 10px 20px; }
            .tender-header { display: none !important; }
            .accordion-button { display: block; text-align: left; width: 100%; }
          </style>
        </head>
        <body>${printContent}</body>
      </html>
    `);
    newWindow.document.close();
    newWindow.focus();
    newWindow.print();
    newWindow.close();
  };

  // ✅ Accordion Header: Section Info
  const getDocumentBySection = (sectionName) => {
    const docs = filteredDocuments.filter(
      (doc) =>
        String(doc?.section || "").trim().toLowerCase() ===
        String(sectionName || "").trim().toLowerCase()
    );

    return (
      <div className="row w-100 m-0">
        <div className="col-12 col-md-6 fw-semibold">
          <span>{sectionName}</span>
        </div>
        <div className="col-12 col-md-2 text-md">
          <span className="d-none d-md-inline fw-semibold">Open Date: </span>
          <br />
          <span>
            {docs?.[0]?.openDate && !isNaN(new Date(docs[0].openDate))
              ? new Date(docs[0].openDate).toLocaleDateString("en-GB")
              : ""}
          </span>
        </div>
        <div className="col-12 col-md-3 text-md">
          <span className="d-none d-md-inline fw-semibold">
            Close Date & Time:
          </span>
          <br />
          <span>
            {docs?.[0]?.closingDate && !isNaN(new Date(docs[0].closingDate))
              ? new Date(docs[0].closingDate).toLocaleString("en-GB", {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                })
              : ""}
          </span>
        </div>
        <div className="col-12 col-md-1 text-md-end">
          <span className="d-none d-md-inline fw-semibold">Status: </span>
          <br />
          <span>{docs?.[0]?.status ? ` ${docs[0].status}` : ""}</span>
        </div>
      </div>
    );
  };

  // ✅ Accordion Body: Render Documents
  const renderDocumentsBySection = (sectionName) => {
    const docs = filteredDocuments.filter(
      (doc) =>
        String(doc?.section || "").trim().toLowerCase() ===
        String(sectionName || "").trim().toLowerCase()
    );

    const grouped = docs.reduce((acc, doc) => {
      const folder = doc?.folderName || doc?.section || "Uncategorized";
      if (!acc[folder]) acc[folder] = [];
      acc[folder].push(doc);
      return acc;
    }, {});

    return (
      <ul className="strip-ul">
        {Object.entries(grouped).map(([folderName, folderDocs], idx) => (
          <li key={idx}>
            <div className="row g-4">
              <div className="col">
                <div className="row g-4">
                  <div className="col-md">
                    <div className="font-16 font-400">
                      <div className="container">
                        <div className="row tender-header d-none d-md-flex">
                          <div className="col-md-6 fw-semibold">File Name</div>
                          <div className="col-md-2 fw-semibold text-end">
                            Open Date
                          </div>
                          <div className="col-md-2 fw-semibold text-end">
                            Closing Date
                          </div>
                          <div className="col-md-2 fw-semibold text-end">
                            Status
                          </div>
                        </div>
                        {folderDocs.map((doc, i) => (
                          <div
                            key={i}
                            className={`row tender-row ${
                              i % 2 === 0 ? "even" : "odd"
                            }`}
                          >
                            <div className="col-12 col-md-6 text-truncate">
                              <span className="d-md-none fw-semibold">
                                File Name:{" "}
                              </span>
                              <a
                                href={`${WebApiURL}File/view/${encryptFileIdValue(
                                  doc.fileId
                                )}`}
                                rel="noopener noreferrer"
                              >
                                {doc.fileName}
                              </a>
                            </div>
                            <div className="col-12 col-md-2 text-md-end">
                              <span className="d-md-none fw-semibold">
                                Open Date:{" "}
                              </span>
                              {doc.openDate &&
                              !isNaN(new Date(doc.openDate))
                                ? new Date(doc.openDate).toLocaleDateString(
                                    "en-GB"
                                  )
                                : ""}
                            </div>
                            <div className="col-12 col-md-3 text-md-center">
                              <span className="d-md-none fw-semibold">
                                Closing Date:{" "}
                              </span>
                              {doc.closingDate &&
                              !isNaN(new Date(doc.closingDate))
                                ? new Date(
                                    doc.closingDate
                                  ).toLocaleString("en-GB", {
                                    day: "2-digit",
                                    month: "2-digit",
                                    year: "numeric",
                                    hour: "2-digit",
                                    minute: "2-digit",
                                    hour12: false,
                                  })
                                : ""}
                            </div>
                            <div className="col-12 col-md-1 text-md-end">
                              <span className="d-md-none fw-semibold">
                                Status:{" "}
                              </span>
                              {doc.status && typeof doc.status === "string"
                                ? doc.status
                                : ""}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
        ))}
      </ul>
    );
  };

  return (
    <>
      {/* ✅ Header with Search and Print */}
      <div className="service-title text-green-38B652 font-700 mb-3 d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-2">
        <div>Request for Quotation</div>
        <div className="d-flex flex-wrap gap-4">
          <input
            type="text"
            className="form-control form-control-sm"
            style={{ width: "320px" }}
            placeholder="Search by file, section, status, or date..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <button
            className="about-btn btn-green-38B652 text-decoration-none"
            onClick={handlePrint}
          >
            Print
          </button>
        </div>
      </div>

      {/* 👇 Accordion */}
      <div className="row g-3 g-sm-4 g-md-4" ref={printRef}>
        <div className="col-12">
          {sections.length === 0 ? (
            <p className="text-muted">No matching documents found.</p>
          ) : (
            <div className="accordion blackTab" id="blackTab">
              {sections.map((sectionName, idx) => (
                <div className="accordion-item" key={sectionName}>
                  <h2 className="accordion-header">
                    <button
                      className={`accordion-button ${
                        activeIndex !== idx ? "collapsed" : ""
                      }`}
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target={`#section-${idx}`}
                      aria-expanded={idx === 0 ? "true" : "false"}
                      aria-controls={`section-${idx}`}
                      onClick={() => setActiveIndex(idx)}
                    >
                      {getDocumentBySection(sectionName)}
                    </button>
                  </h2>
                  <div
                    id={`section-${idx}`}
                    className={`accordion-collapse collapse ${
                      activeIndex === idx ? "show" : ""
                    }`}
                    data-bs-parent="#blackTab"
                  >
                    <div className="accordion-body px-0">
                      {loading ? (
                        <div>Loading documents...</div>
                      ) : (
                        renderDocumentsBySection(sectionName)
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default RFQSubmissions;
